<template>
  <div style="padding-bottom: 50px">
    <el-card>
      <el-input
        style="width: 150px"
        v-model="Name"
        placeholder="搜索资源名称"
      ></el-input>
      <el-button style="margin-left: 10px" type="primary" @click="onClickSearch"
        >查询</el-button
      >
    </el-card>
    <el-table
      :data="tableData"
      style="width: 100%; margin-top: 20px"
      :header-cell-style="{ color: '#000' }"
    >
      <el-table-column label="序号" width="50" align="center">
        <template slot-scope="scope">
          {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="SourceName" label="场馆名称" align="center">
      </el-table-column>
      <el-table-column prop="TeamLeader" label="带队者" align="center">
      </el-table-column>

      <el-table-column prop="ClassName" label="班级" align="center">
      </el-table-column>
      <el-table-column label="参与学生" align="center">
        <template slot-scope="scope">
          <el-popover placement="top-start" width="300" trigger="click">
            <div class="flex" style="flex-wrap: wrap">
              <div
                v-for="(tag, index) in scope.row.Students"
                :key="index"
                style="margin: 5px"
              >
                {{ tag }}
              </div>
            </div>
            <el-button
              icon="el-icon-search"
              slot="reference"
              circle
            ></el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="状态" align="center">
      </el-table-column>
      <el-table-column
        prop="SourceAddress"
        label="地址"
        align="center"
        width="300"
      >
      </el-table-column>
      <el-table-column prop="Time" label="时间" align="center" width="300">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="PageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="PageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="text-align: center;padding:20px; 0 0 0"
    >
    </el-pagination>
  </div>
</template>
<script>
import { GetMakeDetailInfo } from "../../api/api";
export default {
  data() {
    return {
      Name: "",
      PageIndex: 1,
      PageSize: 10,
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.GetMakeDetailInfo();
  },
  methods: {
    getData(val) {
      var content = val.Students.join(",");
      return content;
    },
    onClickSearch() {
      this.PageIndex = 1;
      this.GetMakeDetailInfo();
    },
    //分页
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetMakeDetailInfo();
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.GetMakeDetailInfo();
    },
    async GetMakeDetailInfo() {
      let res = await GetMakeDetailInfo({
        ScoreName: this.Name,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
</style>